import type { ColorMode } from "./agents";

/**
 * Section-highlight tints used to color-code eForce model sections in the
 * report editor. Light set = historical pastels (dark text on tinted
 * background); dark set = same hues re-seated at hsl(hue, 35%, 26%) so light
 * text stays readable.
 */
const HIGHLIGHT_LIGHT = [
  "#FFF98F",
  "#BCF1FF",
  "#FFE5D9",
  "#FFF9C4",
  "#DFFFE2",
  "#E3F2FD",
  "#F3E5F5",
  "#FDE2E4",
  "#ECEFF1",
  "#F1F8E9",
] as const;

const HIGHLIGHT_DARK = [
  "#5a572b",
  "#2b4f5a",
  "#5a3a2b",
  "#5a552b",
  "#2b5a30",
  "#2b465a",
  "#532b5a",
  "#5a2b2e",
  "#2b475a",
  "#445a2b",
] as const;

export const getHighlightColors = (mode: ColorMode = "light"): readonly string[] =>
  mode === "dark" ? HIGHLIGHT_DARK : HIGHLIGHT_LIGHT;
